import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'


@autobind
class WorkStudent extends Component {
  render () {
    let studentName = this.props.student_type && this.props.student_type.account.first_name && this.props.student_type.account.first_name.length > 1 ? this.props.student_type.account.first_name : 'Student'
    let studentFirstname = this.props.student_type && this.props.student_type.account.first_name ? this.props.student_type.account.first_name : 'Student'
    let studentAvatar = this.props.student_type && this.props.student_type.account.avatar
    let schoolName = this.props.school && this.props.school.policy && this.props.school.policy.can_show_link_to_school_on_WV ? <a href={'/schools/' + this.props.school.id}>{this.props.school && this.props.school.title}</a> : this.props.school && this.props.school.title
    return (
      <section className='workStudent'>
        <div className='workStudent__author'>
          <PobbleAvatar avatar={studentAvatar} name={studentFirstname} style={{fontSize: '40px'}} className='workStudent__initial' />
          <div>
            <h3 className='workStudent__author__name'>{studentName}</h3>
            <small className='workStudent__author__desc'>{schoolName}</small>
          </div>
        </div>
        <span className={'workStudent__year year year--' + this.props.year_group.order}>{this.props.year_group.title}</span>
      </section>
    )
  }
}

export default WorkStudent

WorkStudent.propTypes = {
  student: PropTypes.object,
  year_group: PropTypes.object
}



// WEBPACK FOOTER //
// ./components/work/WorkStudent.js